/**
 * ProfileView state updated Actions
 */
export const PROFILE_VIEW_STATE_UPDATED = 'PROFILE_VIEW_STATE_UPDATED';
export function ebProfileViewStateUpdated(ebProfileViewState) {
  return {
    type: PROFILE_VIEW_STATE_UPDATED,
    ebProfileViewState: ebProfileViewState,
  };
}
